import { render, staticRenderFns } from "./Story.vue?vue&type=template&id=815f8f48"
import script from "./Story.vue?vue&type=script&lang=js"
export * from "./Story.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports